<script>
    import { link } from "svelte-spa-router";

    import ProdottiServizi from "./components/ProdottiServizi.svelte";
    const routes = {
        "/prodotti-servizi": ProdottiServizi,
    };
</script>

<section style="background: #EA005F;">
    <div
        style="height: 600px;background: url(&quot;assets/img/brands/bg_txt.svg&quot;) center / cover;width: 100%;/*background-size: contain;*/background-repeat: no-repeat;box-shadow: inset 0px 0px var(--bs-body-color), 0px 0px 0px;"
    />
    <section />
    <div class="container h-100 position-relative" style="top: -50px;">
        <div class="row gy-5 gy-lg-0 row-cols-1 row-cols-md-2 row-cols-lg-3">
            <div class="col">
                <div class="card border-0 shadow">
                    <div class="card-body pt-5 p-4">
                        <a href="/wi-fi" use:link
                            ><img
                                src="assets/img/brands/wifiTXT.svg"
                                width="241"
                                height="58"
                                style="padding-top: 0px;margin-bottom: -3px;width: 100%;height: 100px;"
                                alt="Offerte Wi-Fi"
                            /></a
                        >
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card border-0 shadow">
                    <div
                        class="card-body pt-5 p-4"
                        style="margin-top: -2px;padding-top: 67px;padding-left: 6px;padding-right: 4px;padding-bottom: 10px;"
                    >
                        <a href="/fibra" use:link>
                            <img
                                src="assets/img/brands/fibraTXT.svg"
                                width="256"
                                height="100"
                                style="width: 100%;height: 100px;"
                                alt="Offerte Fibra"
                            /></a
                        >
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card border-0 shadow">
                    <div class="card-body pt-5 p-4">
                        <img
                            src="assets/img/brands/cloudTXT.svg"
                            width="266"
                            height="60"
                            style="height: 100px;width: 100%;"
                            alt="Servizi Cloud"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section />
</section>
<section>
    <div class="container py-4 py-xl-5">
        <div class="row mb-5">
            <div class="col-md-8 col-xl-6 text-center mx-auto">
                <h2>Top Quality</h2>
                <p class="w-lg-50">
                    La nostra connettività è esattamente quello che ti manca per
                    avere tutto.
                </p>
            </div>
        </div>
        <div
            class="row gy-4 gy-xl-0 row-cols-1 row-cols-md-2 row-cols-xl-3 d-xl-flex align-items-xl-center gutter-y"
        >
            <div class="col">
                <div class="card">
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <div class="card-body text-center p-4">
                        <img
                            src="assets/img/brands/LIRS_icone%20sito-WIFI.svg"
                            width="249"
                            height="129"
                        />
                        <!-- svelte-ignore a11y-missing-content -->
                        <h6 class="text-uppercase text-muted card-subtitle" />
                        <h4 class="display-4 fw-bold card-title">19,50 €</h4>
                    </div>
                    <div class="card-footer p-4">
                        <div>
                            <ul class="list-unstyled">
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Internet illimitato</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>supporto VoIP</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Connettività Wireless 5GhZ</span>
                                </li>
                            </ul>
                        </div>
                        <a
                            class="btn btn-primary d-block w-100"
                            role="button"
                            href="#">Vedi Offerta</a
                        >
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card border-primary border-2">
                    <div class="card-body text-center p-4">
                        <span
                            class="badge rounded-pill bg-primary position-absolute top-0 start-50 translate-middle text-uppercase"
                            >Più Richiesto</span
                        >
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <h6 class="text-uppercase text-muted card-subtitle">
                            <img
                                src="assets/img/brands/LIRS_icone%20sito_FIBRA.svg"
                                width="168"
                                height="147"
                            />
                        </h6>
                        <h4 class="display-4 fw-bold card-title">29,90 €</h4>
                    </div>
                    <div class="card-footer p-4">
                        <div>
                            <ul class="list-unstyled">
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Internet illimitato</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span
                                        >Velocità in Download fino ad 1 Gbps</span
                                    >
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span
                                        >Velocità in upload fino a 100 mega</span
                                    >
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>supporto VoIP</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span
                                        >Assistenza 24/7 tramite
                                        chat/ticket/centralino</span
                                    >
                                </li>
                            </ul>
                        </div>
                        <a
                            class="btn btn-primary d-block w-100"
                            role="button"
                            href="#">vedi offerta</a
                        >
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-body text-center p-4">
                        <h6 class="text-uppercase text-muted card-subtitle">
                            <img
                                src="assets/img/brands/wifiVoIP.svg"
                                width="275"
                                height="118"
                                alt="voip"
                            />
                        </h6>
                        <h4 class="display-4 fw-bold card-title">
                            &nbsp;22,90€
                        </h4>
                    </div>
                    <div class="card-footer p-4">
                        <div>
                            <ul class="list-unstyled">
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Internet illimitato</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span
                                        >Chiamate illimitato su tutto il
                                        territorio nazionale</span
                                    >
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>connettività wireless 4.0</span>
                                </li>
                            </ul>
                        </div>
                        <a
                            class="btn btn-primary d-block w-100"
                            role="button"
                            href="/">vedi offerta</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section
    class="text-bg-primary"
    style="background: url(&quot;assets/img/brands/LIRS_file-07.svg&quot;) center;/*height: 800px;*/"
>
    <section class="py-4 py-xl-5">
        <div class="container">
            <div
                class="bg-dark border rounded border-0 border-dark overflow-hidden"
            >
                <div class="row g-0">
                    <div class="col-md-6">
                        <div class="text-white p-4 p-md-5">
                            <h2 class="fw-bold text-white mb-3">
                                Realizziamo soluzioni per rendere la vita più
                                facile ai nostri clienti.
                            </h2>
                            <p class="mb-4">
                                Con l’ingresso nell’era della #NextConnection e
                                grazie ad un modello di business innovativo,
                                LIRS in Italia fonda la cultura della
                                sostenibilità, ponendo al centro dell’impresa
                                l’uomo, creando così un nuovo modello
                            </p>
                            <div class="my-3">
                                <a
                                    class="btn btn-primary btn-lg me-2"
                                    role="button"
                                    href="/prodotti-servizi"
                                    use:link>Prodotti</a
                                ><a
                                    class="btn btn-light btn-lg"
                                    role="button"
                                    href="/prodotti-servizi"
                                    use:link>Servizi</a
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-md-6 order-first order-md-last"
                        style="min-height: 250px;"
                    >
                        <img
                            class="w-100 h-100 fit-cover"
                            src="assets/img/Soft%20skills-rafiki.svg"
                            style="background: var(--bs-tertiary-bg);"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>
<section
    class="text-bg-primary"
    style="/*height: 800px;*/box-shadow: inset 0px 0px 20px 0px var(--bs-body-color);"
>
    <section class="text-bg-light py-4 py-xl-5">
        <div class="container py-4 py-xl-5">
            <h1 class="text-center">
                <strong
                    ><span style="color: rgb(52, 63, 82);"
                        >COSA CI RENDE DIFFERENTI?</span
                    ></strong
                >
            </h1>
            <div class="row gy-4 row-cols-2 row-cols-md-4">
                <div class="col">
                    <div
                        class="text-center d-flex flex-column justify-content-center align-items-center py-3"
                    >
                        <div
                            class="bs-icon-xl bs-icon-circle bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block mb-2 bs-icon lg"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M11 6H13V10.079L16.3413 7.73938L17.4885 9.37768L13.7434 12L17.4885 14.6223L16.3413 16.2606L13 13.921V18H11V13.921L7.65864 16.2606L6.51148 14.6223L10.2565 12L6.51147 9.37769L7.65863 7.73938L11 10.079V6Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </div>
                        <div class="px-3">
                            <h2 class="fw-bold mb-0">1000+</h2>
                            <p class="mb-0">Clienti soddisfatti</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div
                        class="text-center d-flex flex-column justify-content-center align-items-center py-3"
                    >
                        <div
                            class="bs-icon-xl bs-icon-circle bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block mb-2 bs-icon lg"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                                class="bi bi-clipboard-data"
                            >
                                <path
                                    d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z"
                                />
                                <path
                                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                                />
                                <path
                                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                                />
                            </svg>
                        </div>
                        <div class="px-3">
                            <h2 class="fw-bold mb-0">250+</h2>
                            <p class="mb-0">Progetti chiusi</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div
                        class="text-center d-flex flex-column justify-content-center align-items-center py-3"
                    >
                        <div
                            class="bs-icon-xl bs-icon-circle bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block mb-2 bs-icon lg"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                                class="bi bi-graph-up-arrow"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
                                />
                            </svg>
                        </div>
                        <div class="px-3">
                            <h2 class="fw-bold mb-0">4x</h2>
                            <p class="mb-0">
                                Aumento dei ricavi per i nostri clienti
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div
                        class="text-center d-flex flex-column justify-content-center align-items-center py-3"
                    >
                        <div
                            class="bs-icon-xl bs-icon-circle bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block mb-2 bs-icon lg"
                        >
                            <i class="fa fa-users" />
                        </div>
                        <div class="px-3">
                            <h2 class="fw-bold mb-0">99,7%</h2>
                            <p class="mb-0">Clienti soddisfatti</p>
                        </div>
                    </div>
                </div>
            </div>
            <p class="fs-5 text-center">
                <strong
                    ><span style="color: rgb(52, 63, 82);"
                        >Per LIRS i clienti non sono semplici numeri, ma parte
                        integrante dell’azienda, per questo ascoltiamo sempre le
                        loro esigenze, per potergli dare il servizio perfetto
                        per il loro business.</span
                    ></strong
                >
            </p>
        </div>
    </section>
</section>
<section style="/*height: 500px;*/">
    <div class="container py-4 py-xl-5">
        <div class="row mb-5">
            <div class="col-md-8 col-xl-6 text-center mx-auto">
                <h2>
                    <img
                        src="assets/img/brands/LIRS_file-07.svg"
                        width="107"
                        height="55"
                        alt="prodotti"
                    />Prodotti/Servizi
                </h2>
                <p class="w-lg-50">
                    I servizi che offriamo sono studiati e progettati
                    appositamente per soddisfare le esigenze dei nostri clienti.
                </p>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3">
            <div class="col">
                <div class="d-flex p-3">
                    <div
                        class="bs-icon-sm bs-icon-rounded bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block bs-icon sm"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            viewBox="0 0 20 20"
                            fill="none"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12.3162 3.05134C12.8402 3.22599 13.1233 3.79231 12.9487 4.31625L8.94868 16.3163C8.77404 16.8402 8.20772 17.1234 7.68377 16.9487C7.15983 16.7741 6.87667 16.2077 7.05132 15.6838L11.0513 3.6838C11.226 3.15986 11.7923 2.8767 12.3162 3.05134ZM5.70711 6.29292C6.09763 6.68344 6.09763 7.31661 5.70711 7.70713L3.41421 10L5.70711 12.2929C6.09763 12.6834 6.09763 13.3166 5.70711 13.7071C5.31658 14.0977 4.68342 14.0977 4.29289 13.7071L1.29289 10.7071C0.902369 10.3166 0.902369 9.68344 1.29289 9.29292L4.29289 6.29292C4.68342 5.9024 5.31658 5.9024 5.70711 6.29292ZM14.2929 6.29292C14.6834 5.9024 15.3166 5.9024 15.7071 6.29292L18.7071 9.29292C19.0976 9.68344 19.0976 10.3166 18.7071 10.7071L15.7071 13.7071C15.3166 14.0977 14.6834 14.0977 14.2929 13.7071C13.9024 13.3166 13.9024 12.6834 14.2929 12.2929L16.5858 10L14.2929 7.70713C13.9024 7.31661 13.9024 6.68344 14.2929 6.29292Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                    <div class="px-2">
                        <h5 class="mb-0 mt-1">Software &amp; Integration</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="d-flex p-3">
                    <div
                        class="bs-icon-sm bs-icon-rounded bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block bs-icon sm"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            class="bi bi-robot"
                        >
                            <path
                                d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25.286 25.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"
                            />
                            <path
                                d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"
                            />
                        </svg>
                    </div>
                    <div class="px-2">
                        <h5 class="mb-0 mt-1">Iot Solution</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="d-flex p-3">
                    <div
                        class="bs-icon-sm bs-icon-rounded bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block bs-icon sm"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            class="bi bi-cloud"
                        >
                            <path
                                d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                            />
                        </svg>
                    </div>
                    <div class="px-2">
                        <h5 class="mb-0 mt-1">Cloud Services</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="d-flex p-3">
                    <div
                        class="bs-icon-sm bs-icon-rounded bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block bs-icon sm"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            class="bi bi-wifi"
                        >
                            <path
                                d="M15.384 6.115a.485.485 0 0 0-.047-.736A12.444 12.444 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049z"
                            />
                            <path
                                d="M13.229 8.271a.482.482 0 0 0-.063-.745A9.455 9.455 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065zm-2.183 2.183c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091l.016-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z"
                            />
                        </svg>
                    </div>
                    <div class="px-2">
                        <h5 class="mb-0 mt-1">
                            Fibrer &amp; Wireless Networkin
                        </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="d-flex p-3">
                    <div
                        class="bs-icon-sm bs-icon-rounded bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block bs-icon sm"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            class="bi bi-pc-horizontal"
                        >
                            <path
                                d="M1 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H1Zm11.5 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM1 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM1.25 9h5.5a.25.25 0 0 1 0 .5h-5.5a.25.25 0 0 1 0-.5Z"
                            />
                        </svg>
                    </div>
                    <div class="px-2">
                        <h5 class="mb-0 mt-1">IT Solutions</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="d-flex p-3">
                    <div
                        class="bs-icon-sm bs-icon-rounded bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block bs-icon sm"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            class="bi bi-server"
                        >
                            <path
                                d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4c0 1.473-2.985 2.667-6.667 2.667S1.333 5.473 1.333 4V2.667z"
                            />
                            <path
                                d="M1.333 6.334v3C1.333 10.805 4.318 12 8 12s6.667-1.194 6.667-2.667V6.334a6.51 6.51 0 0 1-1.458.79C11.81 7.684 9.967 8 8 8c-1.966 0-3.809-.317-5.208-.876a6.508 6.508 0 0 1-1.458-.79z"
                            />
                            <path
                                d="M14.667 11.668a6.51 6.51 0 0 1-1.458.789c-1.4.56-3.242.876-5.21.876-1.966 0-3.809-.316-5.208-.876a6.51 6.51 0 0 1-1.458-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z"
                            />
                        </svg>
                    </div>
                    <div class="px-2">
                        <h5 class="mb-0 mt-1">Server Configuration</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="text-bg-primary" style="/*height: 500px;*/">
    <div class="container py-4 py-xl-5">
        <div class="row mb-5">
            <div class="col-md-8 col-xl-6 text-center mx-auto">
                <h1>
                    <img
                        src="assets/img/brands/cloudTXT-White.svg"
                        width="518"
                        height="132"
                    />
                </h1>
                <p class="w-lg-50">
                    Hosting, Server Dedicati, Vps, HOT SPOT per locali,
                    Centralini, Servizi ad hoc
                </p>
            </div>
        </div>
        <div class="row gy-4 row-cols-1 row-cols-md-2 row-cols-xl-3">
            <div class="col">
                <div class="card h-100">
                    <div
                        class="card-body border-0 shadow d-flex flex-column justify-content-between p-4"
                    >
                        <div>
                            <h6 class="text-uppercase text-muted">H-start</h6>
                            <h4 class="display-6 fw-bold">€15,00/anno</h4>
                            <hr />
                            <ul class="list-unstyled">
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>10 caselle email</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>10 db mysql</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Spazio 10 GB</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>NodeJS Ready</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Anti-Spam</span>
                                </li>
                            </ul>
                        </div>
                        <a
                            class="btn btn-primary d-block w-100"
                            role="button"
                            href="#">Vedi offerta</a
                        ><span
                            class="badge bg-primary position-absolute top-0 end-0 rounded-bottom-left text-uppercase"
                            >Hosting</span
                        >
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card border-primary border-2 h-100">
                    <div
                        class="card-body border-0 shadow-lg d-flex flex-column justify-content-between p-4"
                    >
                        <span
                            class="badge bg-primary position-absolute top-0 end-0 rounded-bottom-left text-uppercase"
                            >Server</span
                        >
                        <div>
                            <h6 class="text-uppercase text-muted">VPS</h6>
                            <h4 class="display-6 fw-bold">€ 7,20/mese</h4>
                            <hr />
                            <ul class="list-unstyled">
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>1 Vcups - Intel</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>2 Ram GB</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>20 SSD GB </span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>ISO LINUX</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Backup etc.</span>
                                </li>
                            </ul>
                        </div>
                        <a
                            class="btn btn-primary d-block w-100"
                            role="button"
                            href="#">Vedi Offerta</a
                        >
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card h-100">
                    <div
                        class="card-body border-0 shadow-lg d-flex flex-column justify-content-between p-4"
                    >
                        <div>
                            <h6 class="text-uppercase text-muted">
                                HotSpot-base
                            </h6>
                            <h4 class="display-6 fw-bold">€ 9,90/mese</h4>
                            <hr />
                            <ul class="list-unstyled">
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span
                                        >ROUTER&nbsp;hap Lite RB941 2nD -
                                        LIRSosEd</span
                                    >
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Max Client desiderati&nbsp;30</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Radius&nbsp;</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Landing Page</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>Personalizzazioni</span>
                                </li>
                                <li class="d-flex mb-2">
                                    <span
                                        class="bs-icon-xs bs-icon-rounded bs-icon-primary-light bs-icon me-2"
                                        ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            class="bi bi-check-lg"
                                        >
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                                            />
                                        </svg></span
                                    ><span>etc</span>
                                </li>
                            </ul>
                        </div>
                        <a
                            class="btn btn-primary d-block w-100"
                            role="button"
                            href="#">vedi offerta</a
                        ><span
                            class="badge bg-primary position-absolute top-0 end-0 rounded-bottom-left text-uppercase"
                            >wifi-connection</span
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section style="/*height: 500px;*/">
    <div class="container py-4 py-xl-5">
        <div class="row mb-5">
            <div class="col-md-8 col-xl-6 text-center mx-auto">
                <img
                    src="assets/img/brands/VoipText.svg"
                    width="303"
                    height="164"
                />
            </div>
        </div>
        <p class="text-center">
            Nessun cablaggio separato.<br />Setup "Plug&amp;Play" di telefoni,
            gateway e Voip Provider<br />Connetti le tue filiali e globalizza il
            tuo business attraverso il VoIP.<br />Uso semplificato ed
            implementazione della mobilità in quanto permette di effettuare le
            chiamate anche al di fuori dell’ ufficio<br />Configurazione
            autonoma degli interni da parte degli utenti<br />Risparmio sul
            costo delle chiamate: gli utenti sono sempre raggiungibili dai
            propri colleghi attraverso il proprio numero di interno ovunque si
            trovino grazie al centralino chiamataincloud attivo.&nbsp;
        </p>
        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3">
            <div class="col">
                <div class="d-flex p-3">
                    <div
                        class="bs-icon-sm bs-icon-rounded bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block bs-icon sm"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            viewBox="0 0 20 20"
                            fill="none"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12.3162 3.05134C12.8402 3.22599 13.1233 3.79231 12.9487 4.31625L8.94868 16.3163C8.77404 16.8402 8.20772 17.1234 7.68377 16.9487C7.15983 16.7741 6.87667 16.2077 7.05132 15.6838L11.0513 3.6838C11.226 3.15986 11.7923 2.8767 12.3162 3.05134ZM5.70711 6.29292C6.09763 6.68344 6.09763 7.31661 5.70711 7.70713L3.41421 10L5.70711 12.2929C6.09763 12.6834 6.09763 13.3166 5.70711 13.7071C5.31658 14.0977 4.68342 14.0977 4.29289 13.7071L1.29289 10.7071C0.902369 10.3166 0.902369 9.68344 1.29289 9.29292L4.29289 6.29292C4.68342 5.9024 5.31658 5.9024 5.70711 6.29292ZM14.2929 6.29292C14.6834 5.9024 15.3166 5.9024 15.7071 6.29292L18.7071 9.29292C19.0976 9.68344 19.0976 10.3166 18.7071 10.7071L15.7071 13.7071C15.3166 14.0977 14.6834 14.0977 14.2929 13.7071C13.9024 13.3166 13.9024 12.6834 14.2929 12.2929L16.5858 10L14.2929 7.70713C13.9024 7.31661 13.9024 6.68344 14.2929 6.29292Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                    <div class="px-2">
                        <h5 class="mb-0 mt-1">Numerazione Geografica</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="d-flex p-3">
                    <div
                        class="bs-icon-sm bs-icon-rounded bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block bs-icon sm"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            class="bi bi-robot"
                        >
                            <path
                                d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25.286 25.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"
                            />
                            <path
                                d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"
                            />
                        </svg>
                    </div>
                    <div class="px-2">
                        <h5 class="mb-0 mt-1">Centralino In Cloud</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="d-flex p-3">
                    <div
                        class="bs-icon-sm bs-icon-rounded bs-icon-primary d-flex flex-shrink-0 justify-content-center align-items-center d-inline-block bs-icon sm"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            class="bi bi-server"
                        >
                            <path
                                d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4c0 1.473-2.985 2.667-6.667 2.667S1.333 5.473 1.333 4V2.667z"
                            />
                            <path
                                d="M1.333 6.334v3C1.333 10.805 4.318 12 8 12s6.667-1.194 6.667-2.667V6.334a6.51 6.51 0 0 1-1.458.79C11.81 7.684 9.967 8 8 8c-1.966 0-3.809-.317-5.208-.876a6.508 6.508 0 0 1-1.458-.79z"
                            />
                            <path
                                d="M14.667 11.668a6.51 6.51 0 0 1-1.458.789c-1.4.56-3.242.876-5.21.876-1.966 0-3.809-.316-5.208-.876a6.51 6.51 0 0 1-1.458-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z"
                            />
                        </svg>
                    </div>
                    <div class="px-2">
                        <h5 class="mb-0 mt-1">Centralino onPermise</h5>
                    </div>
                </div>
            </div>
        </div>
        <a
            class="btn btn-primary text-start"
            role="button"
            href="#"
            target="_blank">Visualizza tutte le offerte</a
        >
    </div>
</section>
<section
    class="text-bg-dark"
    style="/*height: 500px;*/margin-top: 25px;margin-bottom: 40px;padding-bottom: 40px;padding-top: 22px;padding-right: 9px;padding-left: 14px;"
>
    <div class="container">
        <div class="row">
            <div class="col-md-12" style="margin-bottom: 20px;">
                <h1 class="text-center">
                    <img
                        src="assets/img/brands/LIRS_file-07.svg"
                        width="79"
                        height="71"
                    />Software center
                </h1>
                <p>
                    Abbiamo realizzato una serie di prodotti Hardware/Sofware
                    pronti all'utilizzo oppure customizzabili in base alle
                    esigenze del cliente.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/logoContadinoInCloud.png"
                            width="137"
                            height="137"
                            style="margin-left: 26px;"
                        />
                        <p class="text-center card-text">Contadino in cloud</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >È un sistema hardware/software che permette di
                                monitorare colture da vaso o in serre.&nbsp;</span
                            >
                        </p>
                        <a class="card-link" href="#">Scheda</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/Presino.svg"
                            width="138"
                            height="138"
                            style="text-align: center;margin-left: 25px;"
                        />
                        <p class="text-center card-text">Presino</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >un sistema intelligente per rendere le case di
                                vecchia e nuova costruzione smart.</span
                            >
                        </p>
                        <a class="card-link" href="#">Scheda</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/brands/chiamaIncloud.svg"
                            width="194"
                            height="137"
                        />
                        <p class="text-center card-text">Chiamaincloud,it</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >un sistema intelligente per rendere le case di
                                vecchia e nuova costruzione smart.</span
                            >
                        </p>
                        <a class="card-link" href="#">Vai al servizio</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/OpenPa.png"
                            width="114"
                            height="114"
                            style="margin-left: 37px;margin-bottom: -3px;"
                        />
                        <p class="text-center card-text">openpa.app</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >Tutto il software per la pubblica
                                amministrazione.</span
                            ><br /><span style="color: rgb(96, 93, 186);"
                                >portali web, totem, sistemi di monitoraggio e
                                etc.</span
                            >
                        </p>
                        <a class="card-link" href="#">vai al sito</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 15px;">
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/LogoVendo.png"
                            width="137"
                            height="137"
                            style="margin-left: 26px;"
                        />
                        <p class="text-center card-text">VENDO</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >local e-commerce app. Servizio in cloud
                                dedicato alla vendita on line dei piccoli
                                negozianti e artigiani,</span
                            >
                        </p>
                        <a class="card-link" href="#">Richiedi info</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/LogoConsegno.png"
                            width="138"
                            height="138"
                            style="text-align: center;margin-left: 25px;margin-bottom: 24px;"
                        />
                        <p class="text-center card-text">CONSEGNO</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >Piattaforma cloud per la gestione del servizio
                                di local delivery per bar, ristoranti, pub e
                                pizzerie</span
                            >
                        </p>
                        <a class="card-link" href="#">Scheda</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/VideoCall.png"
                            width="139"
                            height="139"
                            style="margin-left: 27px;margin-bottom: 46px;"
                        />
                        <p class="text-center card-text">MEETING</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >Crea le tue video conferenze private su server
                                dedicato</span
                            >
                        </p>
                        <a class="card-link" href="#">Scheda</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/idtap-2.png"
                            width="114"
                            height="114"
                            style="margin-left: 37px;margin-bottom: 12px;"
                        />
                        <p class="text-center card-text">IDTAP</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >IDtap è "IL BIGLIETTO DA VISITA INTELLIGENTE."
                                I Biglietti idtap sono dotati di tecnologia NFC
                                integrata, condividi i tuoi contatti, mail,
                                sito, social,etc.</span
                            >
                        </p>
                        <a class="card-link" href="#">Vedi Scheda</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="text-bg-primary py-4 py-xl-5">
    <div class="container h-100">
        <div class="text-white bg-primary border rounded border-0 p-4 py-5">
            <div class="row h-100">
                <div
                    class="col-md-10 col-xl-8 text-center d-flex d-sm-flex d-md-flex justify-content-center align-items-center mx-auto justify-content-md-start align-items-md-center justify-content-xl-center"
                >
                    <div>
                        <h1 class="text-uppercase fw-bold text-white mb-3">
                            Contattaci
                        </h1>
                        <p class="mb-4">
                            Vuoi attivare un nostro servizio ma non sai quale
                            sia quello giusto?
                        </p>
                        <p class="mb-4">
                            chiamaci, oppure inviaci una mail a :
                            supporto@lirs.online
                        </p>
                        <img
                            src="assets/img/NCentralino-2.svg"
                            width="305"
                            height="56"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
